import { HttpClient } from '@angular/common/http';
import { inject, Injectable, TransferState } from '@angular/core';
import { TranslateLoader, TranslationObject, provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { getTranslationStateKey } from './translate-state';

@Injectable()
class BrowserTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);
  private readonly transferState = inject(TransferState);

  getTranslation(lang: string): Observable<TranslationObject> {
    const transferKey = getTranslationStateKey(lang);
    const cachedTranslation = this.transferState.get<TranslationObject | null>(transferKey, null);

    if (cachedTranslation) {
      this.transferState.remove(transferKey);
      return of(cachedTranslation);
    }

    return this.http.get<TranslationObject>(`/assets/i18n/${lang}.json`);
  }
}

export function translateModuleConfig() {
  return [
    provideTranslateService(),
    provideTranslateLoader(BrowserTranslateLoader),
  ];
}
